import { IInteractionChartFilterSelection } from "types-for/charts/interaction-chart.types";

/**
 * Establish if the filter area has is same area on both sides using labels
 * @param filterArea
 */
export const isFilterSingleSelection = (
    filterArea?: [IInteractionChartFilterSelection, IInteractionChartFilterSelection]
) => {
    // Both sides are selected
    if (Array.isArray(filterArea) && filterArea.length === 2) {
        // Using left side the element at index 0 and right side for the element at index 1
        const [leftSide, rightSide] = filterArea;

        // A selection was sent
        if (leftSide.activeLabel !== null && rightSide.activeLabel !== null) {
            return leftSide.activeLabel === rightSide.activeLabel;
        }

        return false;
    }

    return false;
};
